module.exports = __webpack_public_path__ + "static/media/prod2.4ab1f478.png";